import { cn } from '@virginexperiencedays/tailwind';
import { round } from '../../../utils/roundPrice';

type Props = {
  price: { percentOff?: number; fixedAmountOff?: number };
};

export const PromotionDiscount = ({ price }: Props) => {
  const { percentOff, fixedAmountOff } = price ?? {};
  const isDiscounted = percentOff || fixedAmountOff;
  const discount = fixedAmountOff > 0 ? `£${round(fixedAmountOff, 0)}` : `${round(percentOff, 0)}%`;

  // don't render if no discount
  if (!isDiscounted) return null;

  return (
    <div
      className={cn(
        'absolute z-[1] flex items-center',
        styles.wrapper.mobile,
        styles.wrapper.desktop
      )}
      data-testid="promotion-discount"
    >
      <div
        data-testid="discount-roundel"
        className={cn(
          styles.roundel.default,
          styles.roundel.mobile,
          styles.roundel.largeMobile,
          styles.roundel.tablet,
          styles.roundel.largeTablet,
          styles.roundelVariant.default
        )}
      >
        <span data-testid="discount-amount">{discount}</span>
        <span>OFF</span>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    mobile: 'right-2 top-2',
    desktop: 'sm:right-4 sm:top-4',
  },
  roundel: {
    default:
      'flex flex-col font-inter font-bold items-center justify-center text-center rounded-full border border-white border-[3px] p-2 text-white',
    mobile: 'w-[68px] h-[68px] text-base leading-none',
    largeMobile: 'sm:w-[100px] sm:h-[100px] sm:text-2xl sm:leading-none',
    tablet: 'md:w-[68px] md:h-[68px] md:text-base md:leading-none',
    largeTablet: 'lg:w-[100px] lg:h-[100px] lg:text-2xl lg:leading-none',
  },
  roundelVariant: {
    default: 'bg-background-primary',
    christmas: 'bg-tones-positive-950',
    easter: 'bg-primary-100 text-grey-700',
    'mothers-day': 'bg-primary-100 text-grey-700',
    'fathers-day': 'bg-background-page text-neutral border-border-neutral',
  },
};
